import { state } from 'cerebral/tags'
import { unset, set } from 'cerebral/operators'
import deleteNode from '../actions/deleteNode'
import unsetNodesAfterDelete from '../actions/unsetNodesAfterDelete'
import isDeletedNodeSelected from '../actions/isDeletedNodeSelected'
import deselectAllNodes from '../actions/deselectAllNodes'
import showDialog from 'modules/App/factories/showDialog'

export default [
  deleteNode,
  unsetNodesAfterDelete,
  set(state`node.rebuildTree`, true),
  isDeletedNodeSelected,
  {
    true: [
      deselectAllNodes,
      set(state`media.files`, {}),
      set(state`node.selectedNode.id`, null),
      set(state`node.selectedNode.path`, null),
      showDialog({
        type: 'alert',
        title: {
          key: 'bms.node.dialog.nodeDeleted.title'
        },
        content: {
          key: 'bms.node.dialog.nodeDeleted.content'
        },
        confirm: {},
        dismiss: {
          signal: 'startPage.onShowStartPage',
          args: {}
        }
      })
    ],
    false: []
  },
  unset(state`node.deletedNode`)
]



// WEBPACK FOOTER //
// ./src/modules/Node/chains/deleteNode.js